import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import lsActions from "../../utility/ls.js";
import {actions as systemActions, asyncActions as systemAsyncActions} from "../slices/systemSlice.js";

const listenerMiddleware = createListenerMiddleware();


listenerMiddleware.startListening({
  matcher: isAnyOf(systemActions.setSystemTheme),
  effect: async (action, listenerApi) => {
    const theme = listenerApi.getState().systemState.theme;
    lsActions.addToLs({ key: "theme", value: { theme: theme } });
  },
});


listenerMiddleware.startListening({
  matcher: isAnyOf(systemActions.setSystemLanguage),
  effect: async (action, listenerApi) => {
    const lang = listenerApi.getState().systemState.lang;
    lsActions.addToLs({ key: "lang", value: { lang: lang } });

  },
});




export default listenerMiddleware;
